import { render, staticRenderFns } from "./LessonWordCategory.vue?vue&type=template&id=32f398aa&"
import script from "./LessonWordCategory.vue?vue&type=script&lang=js&"
export * from "./LessonWordCategory.vue?vue&type=script&lang=js&"
import style0 from "./LessonWordCategory.vue?vue&type=style&index=0&id=32f398aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports